import { Component, Inject, OnInit } from '@angular/core';
import { areEqual, DwComponent, DwComponentType, DwEventService, DwExpressionService, DwMediaRepositoryService, DwMenuParams, DwMenuService, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, getParameterByName } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, CourseEntity, CoursePurchaseEntity, ReferenceStatusAllItems, StudentBySchoolQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';



@DwComponent({
  key: 'purchaseCourseUtil',
  name: 'Purchase Course Util',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CoursePurchase,
})
@Component({
  selector: 'app-purchase-course-util',
  templateUrl: './purchase-course-util.component.html',
  // template: `
  //    Purchase Course Util

  //    <pre>{{studentDetails | json }}</pre>
  // `
})
export class PurchaseCourseUtilComponent extends DwSectionBaseComponent {
  coursePurchase: CoursePurchaseEntity;

  formApi: DwMetaDataFormApi;
  courseDetails: CourseEntity[];
  studentCourseDetails: StudentBySchoolQueryEntity[];
  lastFlightSchoolGroupId: number;

  showImage = true;
  currentCourses: CourseEntity[] = [];
  studentDetails: StudentGridData[] = [];

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private dwFormStateService: DwMetaDataFormStateService,
    private dwEventService: DwEventService,
    private schoolRepositoryService: SchoolRepositoryService,
    private dwMenuService: DwMenuService,
    private router: Router,
    private dwMediaRepositoryService: DwMediaRepositoryService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;
  }

  initComplete = false;

  ngOnInit(): void {
    super.ngOnInit();

    this.runAfterFormDataLoaded(() => {
      this.initForm();
    });

    this.formApi.getFormDataChanges<CoursePurchaseEntity>(100).subscribe(() => {
      this.coursePurchase = this.formApi.getFormData();

      this.handleStudentUpdate();
    });

    this.schoolRepositoryService.getAllCoursesWithPackageDetail()
      .subscribe(courseDetails => {
        this.courseDetails = courseDetails;
      });
  }

  lastStudentIds: number[] = [];

  private handleStudentUpdate() {
    if (this.coursePurchase.UseFlightSchoolGroup) {
      this.loadGroupCourseDetails();
      this.lastStudentIds = [];
    } else {
      this.loadStudentCourseDetails();
      this.lastFlightSchoolGroupId = null;
    }
  }

  private loadStudentCourseDetails() {
    const studentIds = this.coursePurchase.CoursePurchaseStudent?.filter(s => !s._isDeleted)?.map(s => s.StudentId) || [];
    
    if (studentIds.length == 0) {
      this.studentCourseDetails = [];
      this.studentDetails = [];

      this.lastStudentIds = [];

      return;
    }

    if (areEqual(studentIds, this.lastStudentIds)) {
      this.setupStudentGridDetails();
      return;
    }

    this.lastStudentIds = [...studentIds];

   


    this.schoolRepositoryService.getStudentsWithCourseDetails(studentIds)
      .subscribe(studentCourseDetails => {
        this.studentCourseDetails = studentCourseDetails;

        this.setupStudentGridDetails();
      });
  }

  private loadGroupCourseDetails() {
    const flightSchoolGroupId = this.coursePurchase.FlightSchoolGroupId;

    if (!flightSchoolGroupId) {
      this.studentCourseDetails = [];

      this.studentDetails = [];
      this.lastFlightSchoolGroupId = null;
    }

    if (flightSchoolGroupId == this.lastFlightSchoolGroupId) {
      this.setupStudentGridDetails();
      return;
    }


    this.lastFlightSchoolGroupId = flightSchoolGroupId;

    this.schoolRepositoryService.getGroupStudentsWithCourseDetails(flightSchoolGroupId)
      .subscribe(studentCourseDetails => {
        this.studentCourseDetails = studentCourseDetails;

        this.setupStudentGridDetails();
      });


  }


  

  setupStudentGridDetails() {
    if (!this.studentCourseDetails || !this.courseDetails) {
      return;
    }

    this.currentCourses = this.getCurrentCourses();

    this.studentDetails = [];
    for (const studentCourseDetail of this.studentCourseDetails) {
      this.studentDetails.push(this.buildStudentDetail(studentCourseDetail, this.currentCourses));
    }
  }

  private buildStudentDetail(studentCourseDetail: StudentBySchoolQueryEntity, currentCourses: CourseEntity[]) {
    let imageUrl = '/assets/img/user-avatar2.png';

    if (studentCourseDetail.DwroMediaMediaPath) {
      imageUrl = this.dwMediaRepositoryService.getImageUrlFromMediaPath(studentCourseDetail.DwroMediaMediaPath);
    }

    const studentData: StudentGridData = {
      studentData: studentCourseDetail,
      studentName: studentCourseDetail.UserIdDisplay,
      studentImageUrl: imageUrl,
      existingCourses: [],
      missingCourses: []
    };

    for (const course of currentCourses) {
      const studentCourse = studentCourseDetail.StudentCourse.find(sc => sc.StudentCourseStatusId == ReferenceStatusAllItems.Active && sc.CourseId == course.CourseId);

      if (studentCourse) {
        studentData.existingCourses.push(course);
      } else {
        studentData.missingCourses.push(course);
      }
    }

    studentData.existingCourseList = studentData.existingCourses.map(c => c.CourseName).join(', ');
    studentData.missingCourseList = studentData.missingCourses.map(c => c.CourseName).join(', ');

    return studentData;
  }

  getCurrentCourses() {
    const currentCourses: CourseEntity[] = [];

    if (this.coursePurchase?.AddCoursePackage) {
      const packageIds = this.coursePurchase.CoursePurchasePackage?.filter(c => !c._isDeleted).map(p => p.PackageId) || [];

      return this.courseDetails.filter(c => packageIds.find(pId => c.PackageCourse.find(pc => pc.PackageId == pId)));
    }

    const courseIds = this.coursePurchase.CoursePurchaseCourse?.filter(p => p._isDeleted==false).map(p => p.CourseId) || [];

    return this.courseDetails.filter(c => courseIds.find(courseId => c.CourseId == courseId));
  }


  //   const coursePurchase = this.formApi.getFormData();

  //   coursePurchase.CoursePurchaseStudent = coursePurchase.CoursePurchaseStudent || [];

  //   for (const studentCourseDetail of this.studentCourseDetails) {
  //     const coursePurchaseStudent = coursePurchase.CoursePurchaseStudent.find(s => s.StudentId == studentCourseDetail.StudentId);

  //     if (!coursePurchaseStudent) {
  //       continue;
  //     }

  //     coursePurchaseStudent.StudentCourse = studentCourseDetail.StudentCourse;
  //   }

  //   this.formApi.patchFormData(coursePurchase);
  // }

  initForm() {
    if (this.initComplete) {
      return;
    }

    this.initComplete = true;
    this.coursePurchase = this.formApi.getFormData();

    this.getStudentIds()
      .subscribe(studentIdsResult => {

        if (studentIdsResult.studentIds.length == 0) {
          return;
        }

        const coursePurchase = AppMetaData.CoursePurchase.CreateEntity();

        coursePurchase.CoursePurchaseStudent = this.coursePurchase.CoursePurchaseStudent || [];

        for (const studentId of studentIdsResult.studentIds) {
          const coursePurchaseStudent = AppMetaData.CoursePurchaseStudent.CreateEntity();

          coursePurchaseStudent.StudentId = studentId;

          coursePurchase.CoursePurchaseStudent.push(coursePurchaseStudent);
        }

        this.formApi.patchFormData(coursePurchase);
      });
  }



  private getStudentIds(): Observable<{ studentIds: number[], hideStudents: boolean }> {

    const result: { studentIds: number[], hideStudents: boolean } = {
      studentIds: [],
      hideStudents: false
    };

    const userIdFromPath = this.getUserIdFromPath();

    let userIds: number[] = [];

    if (userIdFromPath) {
      result.hideStudents = true;

      userIds.push(userIdFromPath);
    } else {
      const userIdsParam = getParameterByName(this.router, 'userIds');

      if (userIdsParam) {
        userIds = userIdsParam.split(',').map(s => parseInt(s));
      }
    }

    if (userIds.length == 0) {
      return of(result);
    }

    return this.schoolRepositoryService.getStudentsFromUserIds(userIds)
      .pipe(map(students => {
        result.studentIds = students.map(s => s.StudentId);

        return result;
      }));
  }

  private getUserIdFromPath(): number {
    if (!this.dwMenuService.menuState?.currentParams) {
      return null;
    }

    const paramsObject = new DwMenuParams();
    Object.assign(paramsObject, this.dwMenuService.menuState.currentParams);

    const params = paramsObject.getAllParams();

    if (params.length == 1) {
      const userId = params[0].paramValue;

      return userId;
    }

  }




}

export interface StudentGridData {

  // Contains all student details
  studentData: StudentBySchoolQueryEntity;
  studentName: string;
  studentImageUrl: string;

  existingCourseList?: string;
  existingCourses: CourseEntity[];

  missingCourseList?: string;
  missingCourses: CourseEntity[];
}